/**
 * 价格区间分布组件
 */

import React from 'react';
import { Row, Col, Card, Tag, Progress } from 'antd';
import { RiseOutlined } from '@ant-design/icons';
import { PRICE_RANGE_COLORS } from '../constants';
import type { PriceRangeStats } from '../types';

interface PriceRangeDistItem extends PriceRangeStats {
    range: string;
}

interface PriceRangeDistributionProps {
    distribution: PriceRangeDistItem[];
    bestPriceRange: PriceRangeDistItem | null;
}

export const PriceRangeDistribution: React.FC<PriceRangeDistributionProps> = ({ distribution, bestPriceRange }) => {
    return (
        <Card size="small" title="价格区间分布（按去重ASIN）" style={{ marginBottom: 12 }}>
            <Row gutter={12}>
                <Col span={8}>
                    <div style={{ marginBottom: 8, fontWeight: 500, fontSize: 13 }}>按产品数量</div>
                    {distribution.map(r => (
                        <div key={r.range} style={{ marginBottom: 6 }}>
                            <span style={{ display: 'inline-block', width: 50 }}>
                                <Tag color={PRICE_RANGE_COLORS[r.range]} style={{ fontSize: 10 }}>
                                    ${r.range}
                                </Tag>
                            </span>
                            <Progress
                                percent={r.count_pct}
                                size="small"
                                strokeColor={PRICE_RANGE_COLORS[r.range]}
                                format={() => `${r.count} (${r.count_pct}%)`}
                                style={{ width: 'calc(100% - 55px)', display: 'inline-block' }}
                            />
                        </div>
                    ))}
                </Col>
                <Col span={8}>
                    <div style={{ marginBottom: 8, fontWeight: 500, fontSize: 13 }}>按销量占比</div>
                    {distribution.map(r => (
                        <div key={r.range} style={{ marginBottom: 6 }}>
                            <span style={{ display: 'inline-block', width: 50 }}>
                                <Tag color={PRICE_RANGE_COLORS[r.range]} style={{ fontSize: 10 }}>
                                    ${r.range}
                                </Tag>
                            </span>
                            <Progress
                                percent={r.sales_pct || 0}
                                size="small"
                                strokeColor={PRICE_RANGE_COLORS[r.range]}
                                format={() => `${(r.total_sales || 0).toLocaleString()} (${r.sales_pct || 0}%)`}
                                style={{ width: 'calc(100% - 55px)', display: 'inline-block' }}
                            />
                        </div>
                    ))}
                </Col>
                <Col span={8}>
                    <div style={{ marginBottom: 8, fontWeight: 500, fontSize: 13 }}>按销售额占比</div>
                    {distribution.map(r => (
                        <div key={r.range} style={{ marginBottom: 6 }}>
                            <span style={{ display: 'inline-block', width: 50 }}>
                                <Tag color={PRICE_RANGE_COLORS[r.range]} style={{ fontSize: 10 }}>
                                    ${r.range}
                                </Tag>
                            </span>
                            <Progress
                                percent={r.revenue_pct || 0}
                                size="small"
                                strokeColor={PRICE_RANGE_COLORS[r.range]}
                                format={() => `$${(r.total_revenue || 0).toLocaleString()} (${r.revenue_pct || 0}%)`}
                                style={{ width: 'calc(100% - 55px)', display: 'inline-block' }}
                            />
                        </div>
                    ))}
                </Col>
            </Row>
            {bestPriceRange && (
                <div
                    style={{
                        marginTop: 10,
                        padding: 10,
                        background: '#f6ffed',
                        borderRadius: 6,
                        border: '1px solid #b7eb8f',
                        fontSize: 13,
                    }}
                >
                    <RiseOutlined style={{ color: '#52c41a', marginRight: 8 }} />
                    <strong>洞察：</strong>价格区间{' '}
                    <Tag color={PRICE_RANGE_COLORS[bestPriceRange.range]}>${bestPriceRange.range}</Tag>
                    销量占比最高 ({bestPriceRange.sales_pct}%)，共{bestPriceRange.count}个产品，销售额$
                    {(bestPriceRange.total_revenue || 0).toLocaleString()}
                </div>
            )}
        </Card>
    );
};
